const getContentObject = ({ titleText, subTitleText }) => ({
    title: {
        text: titleText,
        dataAid: 'title'
    },
    subtitle: {
        text: subTitleText,
        dataAid: 'subtitle'
    },
});

const MISCELLANEOUS = {
    pageDataAid: "unsubscribe",
    headerDataAid: "unsubscribe",
    pageTitle: {
        text: "Email subscriptions",
    },
    subtitle: {
        text: "Subscribe or unsubscribe to our emails from here",
    },
    toggleDataAid: 'subscription',
    toggleSuccessToast: {
        text: (enabled) => enabled ? 'Subscribed' : 'Unsubscribed'
    },
    toggleFailureToast: {
        text: "Something went wrong! Please try again"
    }
}

const CONTENT = {
    newsLetterContentRow: {
        rowDataAid: "newsletterContent",
        ...getContentObject({
            titleText: 'Newsletter',
            subTitleText: "Investment ideas, reports/market insights"
        }),
    },
    productReleaseRow: {
        rowDataAid: "productRelease",
        ...getContentObject({
            titleText: "Product/feature releases",
            subTitleText: "App updates, enhancements & campaigns",
        }),
    },
    marketingEmailRow: {
        rowDataAid: "marketingEmailContent",
        ...getContentObject({
            titleText: "Marketing/promotional emails",
            subTitleText: "Special offers, deals & new launches"
        }),
    }
}

const UNSUBSCRIBE = {
    ...MISCELLANEOUS,
    CONTENT
}

export default UNSUBSCRIBE
